import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionAudioInput"
const OptionAudioInputIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m16 13c1.104 0 2-.896 2-2v-5h3v-2h-4v5.27c-.29-.17-.64-.27-1-.27-1.104 0-2 .896-2 2s.896 2 2 2m-.75 4h-1.25v-2h-1.004c-.55 0-.996-.447-.996-.999v-11.002c0-.552.456-.999.996-.999h9.008c.55 0 .996.447.996.999v11.002c0 .552-.456.999-.996.999h-4.004v2h-1.25c0 2.624-2.126 4.75-4.75 4.75s-4.75-2.126-4.75-4.75v-4c0-1.795-1.455-3.25-3.25-3.25h-2v-1.5h2c2.624 0 4.75 2.126 4.75 4.75v4c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25" />
    </svg>
  )
}
export default OptionAudioInputIcon
